import { memo, useEffect } from 'react'
import classNames from 'classnames'
import './EditAlertPopup.scss'
import { DELETE_TEXT, EDIT_TEXT } from '../../../../utils/constants'

export const EditAlertPopup = memo(
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  ({ alertId, setIsPopUpOpened, setDeleteAlertId, setEditAlertId, editContainerId }) => {
    useEffect(() => {
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      const listenerCallback = (e) => {
        if (e.target.className !== 'edit-tool-popup-item' && e.target.className !== 'alert-card-tools') {
          setIsPopUpOpened(false)
        }
      }
      document.addEventListener('click', listenerCallback)
      return () => document.removeEventListener('click', listenerCallback)
    }, [])

    const onScrollUpAlertCard = () => {
      const alertsSection = document.getElementById(editContainerId)
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      alertsSection.scrollTo(0, 0)
    }

    const editToolPopUpOptions = [
      {
        name: EDIT_TEXT,
        onClickCallBack: () => {
          setEditAlertId(alertId)
          onScrollUpAlertCard()
          setIsPopUpOpened(false)
        },
      },
      {
        name: DELETE_TEXT,
        onClickCallBack: () => {
          setDeleteAlertId(alertId)
          setIsPopUpOpened(false)
        },
      },
    ]

    return (
      <div className='edit-tool-popup-container'>
        {editToolPopUpOptions.map(({ name, onClickCallBack }) => (
          <div
            role='presentation'
            className={classNames('edit-tool-popup-item', {
              edit: name === EDIT_TEXT,
              delete: name === DELETE_TEXT,
            })}
            key={name}
            onClick={onClickCallBack}>
            {name}
          </div>
        ))}
      </div>
    )
  },
)
